<template>
  <div v-if="photo && (!me || (me && Object.keys(info).length > 0))">
    <v-divider />
    <v-container class="py-6">
      <v-row>
        <v-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2">
          <div v-if="me">
            <div v-if="info && photo">
              <div id="curate">
                <div v-if="info.isPhotoOwnedByUserId" class="text-center">
                  <h3 class="text-h6 font-weight-bold">
                    <v-icon medium class="mr-2">fal fa-ban</v-icon>
                    You cannot curate your own photos
                  </h3>
                </div>
                <div v-else>
                  <!-- Already curated -->
                  <div v-if="info.isCurated" class="text-center">
                    <h3 class="text-h6 font-weight-bold">
                      <v-icon medium class="mr-2">fal fa-thumbs-up</v-icon>
                      You curated this photo {{ info.curationDate | timeago }}
                    </h3>
                  </div>
                  <!-- End Already curated -->
                  <!-- Blocked user -->
                  <div v-else-if="info.isThisUserBlocked" class="text-center">
                    <h3 class="text-h6 font-weight-bold">
                      <v-icon medium class="mr-2">fal fa-ban</v-icon>
                      You cannot curate this user's photo
                    </h3>
                  </div>
                  <!-- End Blocked user -->
                  <!-- All Users -->
                  <div v-else class="text-center">
                    <p>
                      Please express your opinion about this photo
                    </p>
                    <v-btn dark depressed @click="openCurationDialog(photo)">
                      {{
                        photo.statusName === types.photo.status.inCuration
                          ? 'Curate'
                          : 'Evaluate'
                      }}
                    </v-btn>
                  </div>
                  <!-- End All Users -->
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div>
              <h3 class="text-h6 font-weight-bold">
                <v-icon medium class="mr-2">fa-sign-in-alt</v-icon>
                You need to log in to curate this photo.
              </h3>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider />
    <Curation-dialog
      :full="photo.statusName === types.photo.status.inCuration"
    />
  </div>
</template>

<script>
import moment from 'moment'
import types from '@/utils/types'

export default {
  name: 'PhotoCurate',
  filters: {
    timeago: date => {
      return moment
        .utc(date)
        .local()
        .fromNow()
    }
  },
  components: {
    CurationDialog: () => import('@/components/account/curation/CurationDialog.vue')
  },
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      types
    }
  },
  methods: {
    openCurationDialog(photo) {
      this.$store.dispatch('account/resetSorround')
      this.$store.dispatch('account/setCurationDialog', {
        visible: true,
        photo
      })
    }
  }
}
</script>
